import { TabWrap } from 'sections/TabWrap';

import { useZone } from './Zone.hooks';

export function Zone(): React.ReactElement {
  const { sections } = useZone();

  return <TabWrap sections={sections} />;
}
